<div class="posted-order-line-items--wrapper relative">
  <table class="lum-table lum-table--classic striped">
    <thead>
      <tr class="table__head-row">
        <th>ID</th>
        <th>Shipment Date</th>
        <th>Tracking Number</th>
        <th>Cost</th>
        <th>Status</th>
        <th width="30px">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="
          let shipstationShipment of shipstationShipments;
          trackBy: trackByValue
        "
      >
        <tr>
          <td>{{ shipstationShipment?.shipmentId }}</td>
          <td>{{ shipstationShipment.shipDate | date: 'mediumDate' }}</td>
          <td>{{ shipstationShipment?.trackingNumber }}</td>
          <td>{{ shipstationShipment?.shipmentCost | currency }}</td>
          <td>{{ shipstationShipment?.status }}</td>
          <td class="table__actions">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <i class="flaticon-more"></i>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="createInvoiceFromShipment(shipstationShipment.id)"
              >
                Create Invoice From Shipment
              </button>
            </mat-menu>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
